export default "__VITE_ASSET__uXgmPpLn__"